import React, { useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
// Because of the DOM structure of the modal, we need to render the form buttons
// outside of the form, but during the form component render.
// We accomplish this with a React Portal that renders the buttons into a target
// Modal footer rather than the default location (inside the Form)
// To ensure that submit behaviour works, we need to connect the submit button
// to the form using the formId prop.
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-form
export default function useModalFooter(formId, onClose, renderButtons) {
    const footerRef = useRef();
    const footer = React.createElement("div", { className: 'kal-form-modal-footer', ref: footerRef });
    const handleRenderFormButtons = useCallback((...args) => {
        if (footerRef.current) {
            return createPortal(renderButtons(...args, onClose, formId), footerRef.current);
        }
        return null;
    }, [renderButtons, onClose, formId]);
    return { footer, handleRenderFormButtons };
}
//# sourceMappingURL=useModalFooter.js.map